import React from "react";
import { get } from "lodash";
import moment from "moment-timezone";
import Link from "redux-first-router-link";

import { Org } from "lib/models/Org";
import { Message } from "lib/models/Message";

import { renderModifiedCell } from "utils";

// not currently used
// import ErrorIcon from '@material-ui/icons/Error'
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import NotInterestedIcon from "@material-ui/icons/NotInterested";

export const pricingUrl = "https://youtu.be/_caMQpiwiaU";
export const blumiraAgentSetupUrl = "https://youtu.be/_caMQpiwiaU";

export const baseInstallScriptCommand = `[Net.ServicePointManager]::SecurityProtocol = [Net.SecurityProtocolType]::Tls12; . { iwr -useb http://dl.blumira.com/agent/poshim.ps1 }| iex; Blumira-Installer -Configuration https://dl.blumira.com/agent/poshim_config.json -Agent`;

export const getInstallationScript = (keyValue) =>
  baseInstallScriptCommand + " " + keyValue;

export const agentSources = ["windows", "http_access", "agent_os"];

// devicesTableColumns are searchable the rest of deviceDetails
// is for displaying in the device's detail dialog view

export const deviceFields = [
  {
    title: "Device hostname",
    field: "hostname",
    searchable: true,
  },
  {
    title: "Agent status",
    field: "alive",
    searchable: true,
    renderValue: (column, model) => {
      // if alive is set to a date the device is online
      const textToDisplay = model[column.field] ? "Online" : "Offline";

      if (!model[column.field]) {
        return (
          <span style={{ display: "flex", alignItems: "center" }}>
            <NotInterestedIcon style={{ color: "red", marginRight: 5 }} />{" "}
            {textToDisplay}
          </span>
        );
      }

      return textToDisplay;
    },
  },
  {
    title: "Logs",
    renderDetailText: (column, model) => {
      return (
        <Link target={"_blank"} to={getPageActionToDispatch(model)}>
          View device logs <OpenInNewIcon />
        </Link>
      );
    },
  },
  {
    title: "Unresolved findings",
    renderDetailText: (column, model) => {
      const deviceNameForFilter = get(model, ["hostname"], "");

      return (
        <Link
          target={"_blank"}
          to={{
            type: "PAGE",
            payload: {
              orgId: model.orgId,
              toplevel: "reporting",
              secondlevel: "findings",
            },
            query: {
              status: 0,
              deviceName: deviceNameForFilter,
            },
          }}
        >
          View unresolved findings <OpenInNewIcon />
        </Link>
      );
    },
    // searchable: true,
    // renderValue: (column, model) => {
    //     // if not 0
    //     if(model[column.field]){
    //         return (
    //             <span style={{ display: 'flex', alignItems: 'center' }}>
    //                 <ErrorIcon style={{ color: 'red', marginRight: 5 }}/> {model[column.field]}
    //             </span>
    //         )
    //     }

    //     return model[column.field]
    // }
  },
  {
    title: "Internal IP",
    field: "internalIP", // this value is requested from LC and not stored
  },
  {
    title: "External IP",
    field: "externalIP", // this value is requested from LC and not stored
  },
  {
    title: "Mac address",
    field: "macAddr", // this value is requested from LC and not stored
  },
  {
    title: "First seen",
    field: "firstSeen", // this value is requested from LC and not stored
  },
  {
    title: "Host isolation",
    field: "isIsolated",
    searchable: true,
    hideDetails: true,
    renderValue: (column, model) =>
      model[column.field] ? "Isolated" : "Not isolated",
  },

  {
    title: "Last modified",
    field: "modified",
    searchable: true,
    renderValue: (column, model) => renderModifiedCell(column, model),
  },
];

export const deviceDetailsFields = deviceFields.filter(
  ({ hideDetails }) => !hideDetails
);

export const devicesTableColumns = deviceFields.filter(
  ({ searchable }) => searchable
);

export const getInstallationTableColumns = (curDeviceCount, orgSeatCount) => {
  return [
    {
      title: "Description",
      field: "description",
      searchable: true,
    },
    {
      title: "Installed Devices",
      subTitle: `${curDeviceCount}/${orgSeatCount}`,
      field: "agentCount",
      searchable: true,
    },
    {
      title: "Device Limit Per Key",
      field: "agentSeatCount",
      searchable: true,
    },
  ];
};

export const deviceTableFilters = [
  {
    label: "All devices",
    filterMethod: (allDevices) => allDevices,
  },
  // TODO: Add in lastSeen filter once we have figured out all of the details for the 'alive' property
  // {
  //     label: 'Last seen over 24 hours ago',
  //     filterMethod: () => alert('TODO: 24 hour filter, do somethin\' with it')
  // },
  {
    label: "Online",
    filterMethod: (allDevices) => getFilteredDevices(allDevices, "alive", true),
  },
  {
    label: "Offline",
    filterMethod: (allDevices) =>
      getFilteredDevices(allDevices, "alive", false),
  },
  {
    label: "Isolated",
    filterMethod: (allDevices) =>
      getFilteredDevices(allDevices, "isIsolated", true),
  },
  {
    label: "Not isolated",
    filterMethod: (allDevices) =>
      getFilteredDevices(allDevices, "isIsolated", false),
  },
  // There isn't a 'Unresolved findings' column in the table currently, so I commented this one out for now
  // {
  //     label: 'Unresolved findings',
  //     filterMethod: () => alert('TODO: Unresolved finding filter, do somethin\' with it')
  // }
];

export const getFilteredDevices = (
  allDevicesArray,
  fieldToFilter,
  isTruthy
) => {
  // if no field is specified, return all devices
  if (!fieldToFilter) return allDevicesArray;

  // isTruthy is boolean to check if the provided field
  // on the device model is `true`, else filters
  // where device prop on model is falsey
  if (isTruthy)
    return allDevicesArray.filter((device) => device[fieldToFilter]);

  return allDevicesArray.filter((device) => !device[fieldToFilter]);
};

export const sendEmailToSalesTeam = async (orgName) => {
  const message = new Message({
    type: 30,
    recipient: "sales-direct-ae@blumira.com",
    subject: "Blumira Agent Activation Request",
    body: `Blumira Organization "${orgName}" requested to have the Blumira Agent feature enabled on ${moment().format(
      "MMMM Do YYYY, h:mm:ss a"
    )}.`,
  });

  message.create();
};

export const setLogShippingFeature = async (orgModelJSON, userEmail) => {
  const orgModel = new Org(orgModelJSON);

  // a little hack to get license_features from config because
  // current org in page views is not stored as a model
  const existingLicenseFeatures = get(
    orgModel,
    ["config", "license_features"],
    []
  );

  // for getting a starting number to set as agent seat count
  // for MSP child organziations - default to 5 for NFR accounts
  const agentSeatCountToSet = get(orgModel, ["config", "userCount"], 5);

  // set new LOGSHIPPING feature on model, which grants access
  // to the Blumira Agent portion of the web app
  orgModel.set({
    agentSeatCount: agentSeatCountToSet,
    licenseFeatures: [...existingLicenseFeatures, "LOGSHIPPING"],
  });

  // update org model with LOGSHIPPING feature
  const updatedOrgModelToReturn = await orgModel.update();

  // send summary email to MSP team for internal review
  const messageToSend = new Message({
    type: 30,
    recipient: "msp@blumira.com",
    subject: "MSP Organization: Blumira Agent Activation",
    body: `Blumira Agent feature was activated for MSP Organization "${orgModel.name}" by ${userEmail}`,
  });

  messageToSend.create();

  // return model to page view
  return updatedOrgModelToReturn;
};

export const getPageActionToDispatch = (model) => {
  const endTime = moment
    .utc()
    .endOf("minute")
    .format("YYYY-MM-DDTHH:mm:ss.SSS999");
  const startTime = moment
    .utc()
    .add(-7, "days")
    .startOf("minute")
    .format("YYYY-MM-DDTHH:mm");

  return {
    type: "PAGE",
    payload: {
      id1: 500, // Windows & Blumira Agent Logs global report
      orgId: model.orgId,
      toplevel: "reporting",
      secondlevel: "builder",
    },
    query: {
      "Logger.eq": model.id,
      "created.lt": endTime,
      "created.gt": startTime,
    },
  };
};
